module.exports = __webpack_public_path__ + "static/media/ev-1.2ca205d1.jpg";